import { type AppBus, type AppBusEvents } from '@/services/AppBus';
import { InvariantError } from '@/domain/errors';

// Bus silently drops zero-handler publishes; container is lazy. Without this check, an unresolved
// subscriber means the event vanishes with no error. List turns the silent drop into a boot failure.
export const BOOT_REQUIRED_SUBSCRIBERS: readonly (keyof AppBusEvents)[] = [
  'TOAST_REQUESTED',
  'KEY_DOWN',
  'SIMULATION_COMPLETED',
  'VALIDATION_WARNING',
];

export function assertBootSubscribers(
  bus: AppBus,
  events: readonly (keyof AppBusEvents)[] = BOOT_REQUIRED_SUBSCRIBERS,
): void {
  const missing = events.filter((event) => bus.handlerCount(event) === 0);
  if (missing.length > 0) {
    throw new InvariantError(
      `Boot subscriber check failed: no handler registered for ${missing.join(', ')}. ` +
        `A singleton that subscribes to the bus must be eager-resolved in main.tsx before render ` +
        `(see INVARIANTS rule 20).`,
    );
  }
}
